<template>
<CSelect2
    v-model="sorter"
    :options="options"
    @update="sort"
    class="d-inline-block mb-0"
    :addInputClasses="addInputClasses"
/>
</template>

<script>
export default {
    name: 'SortMe',

    props: {
        options: {
            default() {
                return []
            },
            type: Array,
        },
        addInputClasses: {
            type: [Object, String, Array],
            default: 'small bg-vk text-white w-fit-content'
        },
        value: {
            default: null,
        }
    },

    data() {
        return {
            sorter: this.value
        }
    },

    methods: {
        sort() {
            this.$emit('input', this.sorter)
            this.$emit('sort', this.sorter)
        }
    }
}
</script>